<!-- Modal -->
<div class="modal" [id]="id" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">

    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" id="modalLabel"><i class="fas fa-map-marked-alt fa-lg item pr-2"></i>{{header}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="proceedCancel()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body container">
          <div class="row">
              <div class="col">
                  <div #ele1 style="height:500px" >
                    </div>
              </div>
            </div>  
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="proceedYes()">Close</button>
      </div>
    </div>

  </div>
</div>